import React from 'react'
import { Route, HashRouter, Switch } from 'react-router-dom'
import Tickets from './components/Tickets'
import Account from './components/Account'
import resetPassword from './components/resetPassword'
import Login from './components/Login'
import Register from './components/Register'
import ScrollToTop from './components/ScrollTop'
import { ProtectedRoute } from './protectedRoute'


export default props => (
    <HashRouter>
      <ScrollToTop>
        <Switch>
          <Route exact path='/' component={ Login } />
          <Route exact path='/register' component={ Register } />
          <Route exact path='/resetPassword' component={ resetPassword } />
          <ProtectedRoute exact path='/home' component={ Tickets } />
          <ProtectedRoute exact path='/account' component={ Account } />
        </Switch>
      </ScrollToTop>
    </HashRouter>
  )